import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { Button } from '@/components/shadcn/button'
import { SheetTrigger } from '@/components/shadcn/sheet'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconUploadOutline } from '@icons/IconUploadOutline'
import clsx from 'clsx'
import { resolveUploadNamespace } from '../resolveUploadNamespace'
import { DataTableV2DataRow, DataTableV2DataSchema, DataTableV2UploadFilesAction } from '../types'
import { UploadFilesActionSheet } from './UploadFilesActionSheet'

type UploadFilesTableActionV2Props = {
  action: DataTableV2UploadFilesAction
  dataSchema: DataTableV2DataSchema
  localData: DataTableV2DataRow[]
}

export function UploadFilesTableActionV2({ action, dataSchema, localData }: UploadFilesTableActionV2Props) {
  const namespaceParam = action.parameterMappings?.namespace
  if (!namespaceParam) return null

  const uploadNamespace = resolveUploadNamespace(action, dataSchema, localData)
  const trigger = (
    <TooltipButton tooltip={action.label}>
      <SheetTrigger asChild>
        <Button
          disabled={action.isDisabled}
          className={clsx('h-8', { 'w-8 rounded-full': action.icon })}
          variant="ghost"
          size={action.icon ? 'icon' : 'sm'}
        >
          {action.icon && (
            <DynamicIcon
              iconName={action.icon}
              lazyLoad={false}
              fallback={<IconUploadOutline className="size-6" />}
            />
          )}
          {action.label && <span className={action.icon ? 'sr-only' : ''}>{action.label}</span>}
        </Button>
      </SheetTrigger>
    </TooltipButton>
  )

  return <UploadFilesActionSheet action={action} uploadNamespace={uploadNamespace} trigger={trigger} />
}
